import React, { memo } from "react";
import Lozenge from "@atlaskit/lozenge";
import moment from "moment";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import styles from "./LicenseDetails.module.css";
import useFetch from "../../../hooks/use-fetch";

const LicenseDetails = () => {
  const url = `api/dashboard/widget/license-stats`;
  const { data: licenseDetails, isLoading, error } = useFetch(url);
  const {
    type = "",
    installedDate = "",
    state = "",
  } = {
    ...licenseDetails,
  };

  if (isLoading) {
    return (
      <div className={styles.headerCardContainer}>
        <div className={styles.headerCardTitle}>License</div>
        <div className={styles.headerCardBody}>
          <div className={styles.headerCardField}>
            <Skeleton
              width={"150px"}
              count={1}
              baseColor="lightgrey"
              height={"10px"}
            />
          </div>
          <div className={styles.headerCardField}>
            <Skeleton
              width={"150px"}
              count={1}
              baseColor="lightgrey"
              height={"10px"}
            />
          </div>
          <div className={styles.headerCardField}>
            <Skeleton
              width={"150px"}
              count={1}
              baseColor="lightgrey"
              height={"10px"}
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.headerCardContainer}>
      <div className={styles.headerCardTitle}>License</div>
      {licenseDetails && !error ? (
        <div className={styles.headerCardBody}>
          <div className={styles.headerCardField}>
            <p className={styles.alignleft}> State :&nbsp;</p>
            {state !== "NA" && state !== "" ? (
              <div className={styles.alignleft}>
                <Lozenge
                  appearance={
                    state.toLowerCase() === "active" ? "success" : "removed"
                  }
                  isBold
                  style={{ padding: "20px" }}
                >
                  {state}
                </Lozenge>
              </div>
            ) : (
              state
            )}
          </div>
          <div className={styles.headerCardField}>
            <div className={styles.alignleft}>Type :</div>{" "}
            <div className={styles.alignleft}>{type}</div>
          </div>
          <div className={styles.headerCardField}>
            <p className={styles.alignleft}>Installed on :&nbsp;</p>
            <div className={styles.alignleft}>
              {installedDate !== "NA"
                ? moment.utc(installedDate).format("llll")
                : "NA"}
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default memo(LicenseDetails);
